import { put, call, delay } from 'redux-saga/effects';
import { getCrewInfo, setTaskRoles, getUserRoles, getPreviousTasks, getBetaStation } from '../../utils';
import * as actions from '../../modules/beta/betaStationAction';
import * as erroractions from '../../modules/error/ErrorAction';
import { commonError } from '../../modules/error/ErrorCommonFunction';


export function* fetchBetaStation (action) {
    for(let retryCount = 0; retryCount < 3; retryCount++) {
        try {
            const response = yield call(getBetaStation, action.stationCode, action.companyCode);
            response.data.errorResponseDTO.errorCode === 0 ?
                yield put(actions.fetchBetaStationSuccess(response.data))
                :
                yield put(erroractions.showErrorAction(response.data.errorResponseDTO))
                break
        }
        catch(error){
            if(retryCount < 2 && (JSON.stringify(error.code) === '"ECONNABORTED"' || JSON.stringify(error.message) === '"Network Error"')) {
                yield delay(5000);
            } else {
                commonError(error);
                break;
            }
        }
    }
}
